import ResponsibleGamingModule from './ResponsibleGamingModule';

export default ResponsibleGamingModule;
